export enum EnquirusTabId {
  TO_BE_ADDED = 'to-be-added',
  ADDED = 'added',
}

export enum EnquirusTimepieceStatus {
  SELECTABLE = 'selectable',
  VALID_ADD_VAULT = 'valid-add-vault',
  INVALID_ADD_VAULT = 'invalid-add-vault',
  AUTO_ADD_ENABLED = 'auto-add-enabled',
  LOST_OR_STOLEN = 'lost-or-stolen',
}
